import { render, staticRenderFns } from "./ChooseExpertPurchaseItem.vue?vue&type=template&id=88a5bbda&scoped=true"
import script from "./ChooseExpertPurchaseItem.vue?vue&type=script&lang=js"
export * from "./ChooseExpertPurchaseItem.vue?vue&type=script&lang=js"
import style0 from "./ChooseExpertPurchaseItem.vue?vue&type=style&index=0&id=88a5bbda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a5bbda",
  null
  
)

export default component.exports